var minicart = require('../components/miniCart');
const formFields = require('../formFields/formFields');
var gtm = require('googletagmanager/tagManager');
const { throttle } = require('../utilities');
var debounce = require('lodash/debounce');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
}

/**
 * Ensure exactly one focusable radio per price radiogroup (roving tabindex
 * pattern), consistent with product/base.js's ensureRovingTabindex
 *
 * @return {undefined}
 */
function ensureRefinementRovingTabindex() {
    $('.refinements [role="radiogroup"]').each(function () {
        var $group = $(this);
        var $radios = $group.find('[role="radio"]');
        if (!$radios.length) {
            return;
        }
        $radios.attr('tabindex', '-1');
        var $enabled = $radios.filter('[aria-disabled!="true"]');
        var $selected = $enabled.filter('[aria-checked="true"]').first();
        var $target = $radios.first();
        if ($selected.length) {
            $target = $selected;
        } else if ($enabled.first().length) {
            $target = $enabled.first();
        }
        $target.attr('tabindex', '0');
    });
}

/**
 * Sync the aria-checked/aria-disabled state of radio/checkbox styled
 * refinement filter buttons with their visual checked/disabled indicator
 *
 * @return {undefined}
 */
function syncRefinementAriaChecked() {
    $('.refinements [role="radio"], .refinements [role="checkbox"]').each(function () {
        var $control = $(this);
        var isChecked = $control.find('.span-radio, .span-checkbox').hasClass('checked');
        var isDisabled = $control.is(':disabled') || $control.hasClass('disabled');
        $control.attr('aria-checked', isChecked ? 'true' : 'false');
        $control.attr('aria-disabled', isDisabled ? 'true' : 'false');
    });

    ensureRefinementRovingTabindex();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
    syncRefinementAriaChecked();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.result-count',
        '.sorting-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @param {boolean} isContentSearch - Flag to indicate if the request is for content assets (true) or for product search results (false)
 * @return {undefined}
 */
function getContent($element, $target, isContentSearch) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            if (isContentSearch) {
                $('.js-search-result-counter').empty().append($('.js-content-grid').data('content-count'));
            }
            $('body').trigger('init:handleColorChange');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Adjusts the height of product tile elements to match the maximum height of product names.
 * @function adjustProductTileHeights
 */
function adjustProductTileHeights() {
    var maxProductTileBodyHeight = 0;

    // Loop through each product name and find the maximum height
    $('.product-tile .tile-body').each(function () {
        var height = $(this).css('height', '').height();

        if (height > maxProductTileBodyHeight) {
            maxProductTileBodyHeight = height;
        }
    });

    // Set the height of all product name containers to the maximum height
    $('.product-tile .tile-body').height(maxProductTileBodyHeight);
}

/**
 * updateCartTotals
 * @param {Object} data data 
 */
function updateCartTotals(data) {
    if (data.resources) {
        $('.number-of-items').empty().append(data.resources.numberOfItems);
        $('.minicart-link').attr({
            'aria-label': data.resources.minicartCountOfItems,
            title: data.resources.minicartCountOfItems
        });
    }
    $('.ibcDiscountAmount').addClass('d-none');
    $('.shipping-discount').addClass('d-none');
    $('.coupon-discounts').addClass('d-none');
    if (data.totals) {
        $('.shipping-cost').empty().append(data.totals.totalShippingCost);
        $('.shipping-total-cost').empty().append(data.totals.totalShippingCost);
        $('.tax-total').empty().append(data.totals.totalTax);
        $('.grand-total').empty().append(data.totals.grandTotal);
        $('.grand-total-sum').empty().append(data.totals.grandTotal);
        $('.sub-total').empty().append(data.totals.subTotal);
        if (data.totals.ibcDiscountAmount && data.totals.ibcDiscountAmount.formatted) {
            $('.ibcDiscountAmount').removeClass('d-none');
            var discountText = $('.ibcDiscountAmount').data('label');
            $('.order-discount').first().text(discountText.replace('{percentage}', data.totals.discountPercent));
            $('.order-discount-total').empty()
                .append(data.totals.ibcDiscountAmount.formatted);
        }
        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            $('.shipping-discount').removeClass('d-none');
            $('.shipping-discount-total').empty().append('- ' +
                data.totals.shippingLevelDiscountTotal.formatted);
        }
        if (data.totals.discounts.length > 0) {
            $('.coupon-discounts').removeClass('d-none');
            $('.coupon-discounts').empty()
                .append(data.totals.couponDiscountsHtml);
        }
    }

    if (data.cart && data.cart.numItems !== undefined) {
        $('.minicart-quantity').empty().append(data.cart.numItems);
    }

    if (data.actionUrls) {
        $('.delete-coupon-confirmation-btn').attr('data-action', data.actionUrls.removeCouponLineItem);
    }
    if (data.items) {
        data.items.forEach(function (item) {
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            }
            if (item.renderedPromotions) {
                $('.item-' + item.UUID).empty().append(item.renderedPromotions);
            } else {
                $('.item-' + item.UUID).empty();
            }
            $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        });
    }
}


/**
 * applySortingRule - returns updated url with sort rule applied (if valid url and srule)
 * @param {string} urlString - source url
 * @param {string} srule - sort rule to be applied
 * @returns {string} url string
 */
function applySortingRule(urlString, srule){
    var urlParts = urlString.split('?');
    if (srule && urlParts.length === 2) {
        var path = urlParts[0];
        var parameters = new URLSearchParams(urlParts[1] || '');
        parameters.set('srule', srule);
        return path + '?' + parameters.toString();
    }
    return urlString;
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.search-results').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container-fluid.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            $('body').css('overflow', 'hidden');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.search-results').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container-fluid.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
            $('body').css('overflow', '');
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(debounce(function () {
            // Skip auto-close when the panel is open; mobile scroll can trigger resize
            if ($('.refinement-bar').is(':visible')) {
                return;
            }
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container-fluid.search-results').siblings().attr('aria-hidden', false);
            $('body').css('overflow', '');
        }, 150));
    },

    sort: function () {
        // Handle sort order menu selection
        $('.search-results').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            var srule = new URLSearchParams(this.value.split('?')[1] || '').get('srule');
            $('.search-results [name=sort-order]').attr('data-selected', srule);

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    adjustProductTileHeights();
                    $('body').trigger('init:handleColorChange');
                    $('body').trigger('search:updateDom', '.product-grid');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.search-results').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            let productSelected = $('.product-search').attr('aria-selected');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    $('body').trigger('search:updateDom', '.grid-footer');
                    updateSortOptions(response);
                    formFields.updateSelect();
                    adjustProductTileHeights();
                    $('body').trigger('init:handleColorChange');
                    gtm.searchResultsLoadMore(productSelected);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.search-results').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;

                var sruleValue = $('.search-results [name=sort-order]').attr('data-selected');
                if (sruleValue) {
                    searchUrl = applySortingRule(searchUrl, sruleValue);
                    seoUrl = applySortingRule(seoUrl, sruleValue);
                }
                if (seoUrl) {
                    window.history.pushState({}, null, seoUrl);
                }

                var focusTargetId = $(this).attr('id');
                $.ajax({
                    url: searchUrl,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        formFields.updateSelect();
                        adjustProductTileHeights();
                        $('body').trigger('init:handleColorChange');
                        $.spinner().stop();
                        if (focusTargetId) {
                            $(document.getElementById(focusTargetId)).trigger('focus');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        if (focusTargetId) {
                            $(document.getElementById(focusTargetId)).trigger('focus');
                        }
                    }
                });
            }
        );
    },

    radiogroupKeyboardNav: function () {
        // Arrow/Home/End key navigation for the price radiogroup (roving tabindex pattern)
        $('.search-results').on('keydown', '.refinements [role="radiogroup"] [role="radio"]', function (e) {
            var keys = {
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                HOME: 36,
                END: 35
            };
            var code = e.which || e.keyCode;
            var validCodes = [keys.LEFT, keys.UP, keys.RIGHT, keys.DOWN, keys.HOME, keys.END];
            if (validCodes.indexOf(code) === -1) {
                return;
            }
            e.preventDefault();

            var $current = $(this);
            var $group = $current.closest('[role="radiogroup"]');
            var $radios = $group.find('[role="radio"]');
            var $enabled = $radios.filter(':not(:disabled)[aria-disabled!="true"]');
            var idx = $enabled.index($current);
            if (idx === -1) {
                idx = 0;
            }

            /**
             * Moves focus to the given radio element and updates the roving tabindex
             * @param {JQuery} $target - the radio element to focus
             * @return {undefined}
             */
            function moveTo($target) {
                if (!$target || !$target.length) {
                    return;
                }
                $radios.attr('tabindex', '-1');
                $target.attr('tabindex', '0').trigger('focus');
            }

            if (code === keys.HOME) {
                moveTo($enabled.first());
            } else if (code === keys.END) {
                moveTo($enabled.last());
            } else if (code === keys.LEFT || code === keys.UP) {
                moveTo($enabled.eq(Math.max(idx - 1, 0)));
            } else if (code === keys.RIGHT || code === keys.DOWN) {
                moveTo($enabled.eq(Math.min(idx + 1, $enabled.length - 1)));
            }
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.search-results').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'), true);
            } else {
                $('.js-search-result-counter').empty().append($('.js-content-grid').data('content-count'));
            }
            gtm.searchResultsNavigation('Content');
        });

        // gtm data product results from the search
        $('.search-results').on('click', '.product-search', function () {
            $('.js-search-result-counter').empty().append($('.js-search-result-counter').data('product-count'));
            gtm.searchResultsNavigation('Product');
        });

        // Display the next page of content results from the search
        $('.search-results').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
            gtm.searchResultsLoadMore('false');
        });
    },

    searchResultClick: function () {
        /**
         * Resolve the active search term on the results page
         * @returns {string} the current search term
         */
        function getSearchTerm() {
            var term = $('.search-results').data('search-term');
            if (!term) {
                var match = /[?&]q=([^&]+)/.exec(window.location.search);
                if (match) {
                    var raw = match[1].replace(/\+/g, ' ');
                    try {
                        term = decodeURIComponent(raw);
                    } catch (e) {
                        term = raw;
                    }
                } else {
                    term = '';
                }
            }
            return term;
        }

        // Fire searchResultClick for Product result clicks
        $('.search-results').on('click', '.product-tile a:not(.quickview)', function () {
            var term = getSearchTerm();
            if (!term) { return; }
            var $tile = $(this).closest('.product-tile');
            var $tiles = $tile.closest('.product-grid').find('.product-tile');
            gtm.searchResultClick({
                term: term,
                searchType: 'Product',
                resultName: $tile.data('gtm-product-name'),
                resultPosition: $tiles.index($tile) + 1
            });
        });

        // Fire searchResultClick for Content result clicks
        $('.search-results').on('click', '.content-tile a', function () {
            var term = getSearchTerm();
            if (!term) { return; }
            var $tile = $(this).closest('.content-tile');
            var $tiles = $tile.closest('.content-grid').find('.content-tile');
            var resultName = $tile.find('.content-tile__title').text().trim() || $(this).attr('aria-label');
            gtm.searchResultClick({
                term: term,
                searchType: 'Content',
                resultName: resultName,
                resultPosition: $tiles.index($tile) + 1
            });
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    },

    addtoCart: function () {
        $('body').on('click', '.add-to-cart-button-slick-slot', function () {
            var pid = $(this).data('pid');
            var $product = $(this).closest('.product');
            var $selectedSwatch = $product.find('.swatch-link.selected.swatch-active .swatch-value');
            
            if ($selectedSwatch.length && $selectedSwatch.data('variant-id')) {
                pid = $selectedSwatch.data('variant-id');
            }
            
            var productTile = $product.find('.product-tile');
            var productIndex = productTile.data('gtm-product-index');
            var productListName = productTile.data('gtm-product-list-name');

            var url = $(this).data('url');
            var form = {
                pid: pid,
                productIndex: productIndex,
                quantity: 1,
                productListName: productListName
            };

            $.ajax({
                url: url,
                type: 'post',
                data: form,
                success: function (data) {
                    if (data.gateError && data.error) {
                        // If gate error, redirect to gate closed URL
                        window.location = data.redirectUrl;
                        return;
                    }
                    if (data.cartItemsHTML) {
                        $('.cart-product-items').empty().html(data.cartItemsHTML);
                    }
                    if (data.productData) {
                        gtm.addToCart(data.productData, data.productData.quantity);
                    }
                    if (data.quantityTotal === 1) {
                        gtm.openCart();
                    }
                    $('.minicart').trigger('count:update', data);
                    minicart.miniCartShow();
                    var trayOpened = false;
                    $('body').on('trayModalOpened', function (eTMO, traydata) {
                        if (!trayOpened && data.maxQty && data.maxQty.error && traydata.customClassName.includes('mini-cart-tray')) {
                            $('.minicart-maxqty-error').addClass('alert alert-danger p-4');
                            var errorHtml = '<strong class="title mb-1 font-weight-xbold small d-block">' + data.maxQty.message + '</strong>'
                                + '<p class="m-0 small mk-text-color-black">' + data.maxQty.msg + '</p>';
                            $('.minicart-maxqty-error').append(errorHtml);
                            trayOpened = true;
                        }
                    });
                    updateCartTotals(data);
                },
                error: function () {
                }
            });
        });
    },

    startProductTileHeightSync : function() {
        adjustProductTileHeights();

        $(window).on('resize', throttle(function () {
            adjustProductTileHeights();
        }, 500));
    },

    init: function() {
        // Initialize height sync if on PD PLP
        if ($('.experience-dynamic-productList').length > 0) {
            this.startProductTileHeightSync();
        }

        // Set initial aria-checked state for radio/checkbox styled refinement filters
        syncRefinementAriaChecked();
    }
};
